import base from './base'

let controller = 'industry'
let action = null

const Industry = {
  async listIndustries (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    querys.isPrivate = query.isPrivate !== null ? query.isPrivate ? true : false : null
    action = 'ListIndustries'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async addIndustry (request) {
    let model = {
      name: request.name || null,
      cityId: request.cityId || null,
      isPrivate: request.isPrivate || false
    }
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async updateIndustry (request) {
    let model = {
      id: request.id || request.tid || null,
      name: request.name || null,
      cityId: request.cityId || null,
      isPrivate: request.isPrivate || false
    }
    if (!model.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${model.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async deleteIndustry (industryId) {
    if (!industryId) {
      throw new Error('IndustryId为空')
    }
    action = `Delete/${industryId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }
}

export default Industry